var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-field-layout",
    {
      attrs: {
        validator: _vm.validator,
        "has-focus": _vm.hasFocus,
        "side-grid": _vm.sideGrid,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "label",
            fn: function () {
              return [
                _vm._t("label", function () {
                  return [
                    _vm.label
                      ? _c("base-label", {
                          attrs: {
                            "input-id": _vm.id,
                            label: _vm.label,
                            "hidden-label": _vm.hiddenLabel,
                          },
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "prepend-input",
            fn: function () {
              return [_vm._t("prepend-input")]
            },
            proxy: true,
          },
          {
            key: "append-input",
            fn: function () {
              return [_vm._t("append-input")]
            },
            proxy: true,
          },
          {
            key: "before-input",
            fn: function () {
              return [_vm._t("before-input")]
            },
            proxy: true,
          },
          {
            key: "after-input",
            fn: function () {
              return [_vm._t("after-input")]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _c("autocomplete-input", {
        attrs: {
          id: _vm.id,
          "class-name": _vm.className,
          placeholder: _vm.placeholder,
          disabled: _vm.disabled,
          "raw-value": _vm.valueModel,
          "company-address": _vm.companyAddressMode,
        },
        on: {
          change: _vm.handleAutocomplete,
          "value-change": _vm.handleValueChange,
          focusout: _vm.handleBaseBlur,
          focus: _vm.handleBaseFocus,
          input: _vm.handleInput,
        },
      }),
      _vm._v(" "),
      _vm.maxLength
        ? _c(
            "span",
            {
              staticClass: "floating-validation",
              class: {
                "text-danger bold": _vm.localValueLength > _vm.maxLength,
              },
            },
            [
              _vm._v(
                "\n    (" +
                  _vm._s(_vm.localValueLength) +
                  "/" +
                  _vm._s(_vm.maxLength) +
                  ")\n  "
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }